<template>
  <el-dialog v-model="innerVisible" width="1080px" :close-on-click-modal="false" style="padding: 0px;" align-center
    :show-close="false">
    <div class="dialog-header border-b border-[#e5e5e5]">
      <div class="title">资源入库</div>
      <div class="close cursor-pointer" @click="innerVisible = false">
        收起
        <el-icon>
          <CaretTop />
        </el-icon>
      </div>
    </div>
    <div class="dialog-body relative">

      <div class="flex-1 border-r border-[#e5e5e5] px-[20px] py-[20px]">
        <div class="info-line">
          <div class="team" v-if="currentTeam">{{ currentTeam.name }}({{ files.length }})</div>
          <div class="team" v-else>我的空间({{ files.length }})</div>
          <!-- <div class="hint">请将PSD文件栅格化后使用解析，查看 <a href="#" class="link">导入规范</a></div> -->
        </div>
        <div class="left">

          <div class="file-list ">
            <div class="upload-tile" @click="openAdd">
              <div class="plus">+</div>
              <div class="text">点击上传</div>
            </div>
            <div class="file-item" v-for="(f, i) in files" :key="i">
              <div class="thumb">
                <img v-if="isImage(f)" :src="fileUrl(f)" />
                <div v-else class="file-placeholder">{{ ext(f) }}</div>
                <div class="type-badge">{{ ext(f) }}</div>
                <span class="delete-overlay" @click.stop="onRemoveFile(i)">
                  <el-icon>
                    <Delete />
                  </el-icon>
                </span>
              </div>
              <div class="caption">{{ f.name }}</div>
            </div>
          </div>
          <input ref="localInput" type="file" multiple style="display:none" @change="onAddChange"
            accept=".png,.jpg,.jpeg,.webp,.gif" />
        </div>
      </div>

      <div class="right  px-[20px] py-[20px]">
        <div class="field">
          <div class="label  flex items-center justify-between mb-[20px]"><span> 分类</span> <span class="link"
              @click="openAddCategory">+添加分类</span></div>
          <el-select v-model="form.category" placeholder="未关联分类" style="width:100%">
            <el-option v-for="it in categoryOptions" :key="it.id" :label="it.name" :value="it.id" />
          </el-select>
        </div>
        <div class="field mt-[30px] mb-[30px]">
          <div class="label flex items-center justify-between mb-[20px]"><span> 标签</span> <span class="link"
              @click="openTagPicker">+关联标签</span></div>
          <div class="tags">
            <div class="tag" v-for="(it, index) in form.tags" :key="index">
              <span class="text">{{ it.name }}</span>
              <span class="tag-remove" @click.stop="removeTag(index)">
                <el-icon>
                  <Close />
                </el-icon>
              </span>
            </div>
          </div>
          <div class="text text-[#8a8f99]" v-if="form.tags.length === 0"> 未关联标签</div>
        </div>
        <div class="field">
          <div class="label">存储位置</div>
          <div class="storage">
            <div v-if="currentTeam">资源库：{{ currentTeam?.name || '我的空间' }}</div>
            <div v-else>资源库：我的空间</div>
            <div>文件夹：{{ folder.name || '根目录' }}</div>
          </div>
        </div>
        <div class="btn absolute bottom-[20px] right-[20px]">
          <el-button type="primary" @click="confirmUpload" :loading="uploading"
            :disabled="uploading || !props.files?.length">确定</el-button>
          <el-button @click="innerVisible = false" :disabled="uploading">取消</el-button>
        </div>
      </div>
    </div>
    <div class="w-full h-full absolute top-0 left-0 flex items-center justify-center bg-[rgba(255,255,255,0.5)]"
      style="backdrop-filter: blur(2px);" v-if="uploading">
      <NewLoading :text="loadingtext" />
    </div>

  </el-dialog>
  <el-dialog v-model="tagPickerVisible" width="380px" :close-on-click-modal="true" align-center>
    <div class="tag-picker">
      <div class="tp-search">
        <el-input v-model="tagSearch" placeholder="输入关键词搜索标签" :suffix-icon="Search" />
      </div>
      <div class="tp-add" @click="onAddTag"><span class="plus">+</span> 添加标签</div>
      <div class="tp-list">
        <div class="tp-group" v-for="g in groupedTags" :key="g.letter">
          <div class="tp-letter">{{ g.letter }}</div>
          <div class="tp-items">
            <div class="tp-chip" v-for="it in g.items" :key="it"
              :class="{ active: form.tags.some(x => x.id === it.id) }" @click="toggleTag(it)">
              <span class="name">{{ it.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog v-model="addTagVisible" width="360px" title="新建标签" align-center>
    <div class="add-tag-body">
      <el-input v-model="addTagName" placeholder="请输入标签名称" />
    </div>
    <template #footer>
      <div class="footer">
        <el-button type="primary" @click="confirmAddTag">确定</el-button>
        <el-button @click="addTagVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="addCategoryVisible" width="360px" title="新建分类" align-center>
    <div class="add-cat-body">
      <el-input v-model="addCategoryName" placeholder="请输入分类名称" />
    </div>
    <template #footer>
      <div class="footer">
        <el-button type="primary" @click="confirmAddCategory">确定</el-button>
        <el-button @click="addCategoryVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ref, computed, watch, onMounted } from 'vue'
import { ElDialog, ElButton, ElSelect, ElOption, ElIcon, ElMessage } from 'element-plus'
import { Close, Search, Delete, CaretTop } from '@element-plus/icons-vue'
import { createTag, getTagPage, getCategoryPage, createCategory } from '@/api/ResourceMasonry'
import { resourcerFileUpload } from '@/api/design/resource'
import { useUserStore } from '@/stores/user'
import { multipleChoiceStore } from "@/stores/multipleChoice"
const multipleChoice = multipleChoiceStore()
// @ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'
type UploadDialogProps = {
  visible: boolean,
  folder: {
    type: Object,
    default: () => ({})
  },
  files: File[],
  currentTeam: {
    type: Object,
    default: () => ({})
  },
}

const props = defineProps<UploadDialogProps>()
const emit = defineEmits(['update:visible', 'confirm', 'cancel', 'addFiles', 'removeFile'])

const innerVisible = computed({

  get: () => props.visible,
  set: v => emit('update:visible', v)
})
watch(() => props.visible, (v) => {
  multipleChoice.clearSelected()
})
const form = ref<{ category: string | null, tags: string[] }>({ category: null, tags: [] })
const localTags = ref<string[]>([])
const localCategories = ref<string[]>([])
const tagOptions = computed(() => localTags.value.filter(t => (t as any)?.name !== '全部'))
const categoryOptions = computed(() => localCategories.value.filter(t => (t as any)?.name !== '全部'))

const localInput = ref<HTMLInputElement | null>(null)
const openAdd = () => localInput.value?.click()
const onAddChange = (e: Event) => {
  const fs = Array.from((e.target as HTMLInputElement).files || [])
  const allowedExt = ['png', 'jpg', 'jpeg', 'webp', 'gif']
  const allowedMime = ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
  const ok: File[] = []
  const bad: File[] = []
  for (const f of fs) {
    const ext = (f.name.split('.').pop() || '').toLowerCase()
    const mimeOk = allowedMime.includes(f.type)
    const extOk = allowedExt.includes(ext)
    if (mimeOk || extOk) ok.push(f)
    else bad.push(f)
  }
  if (bad.length) {
    ElMessage.warning('仅支持上传 png/jpg/jpeg/webp/gif 图片')
  }
  emit('addFiles', ok)
}

const isImage = (f: File) => /^image\//.test(f.type)
const fileUrl = (f: File) => URL.createObjectURL(f)
const ext = (f: File) => {
  const n = f.name.split('.')
  return n.length > 1 ? n[n.length - 1].toUpperCase() : 'FILE'
}

const onCancel = () => { innerVisible.value = false; emit('cancel') }
const onConfirm = () => {
  emit('confirm', { category: form.value.category, tags: form.value.tags, files: props.files })
  innerVisible.value = false
}

const tagsSelect = ref()
const focusTags = () => { (tagsSelect.value as any)?.focus?.() }
const removeTag = (t: number) => {
  form.value.tags.splice(t, 1)
}

const tagPickerVisible = ref(false)
const tagSearch = ref('')
const openTagPicker = () => {
  getTagPagedata()
  tagPickerVisible.value = true
}

const dataTags = computed(() => tagOptions.value.filter(t => (t as any)?.name.length))
const filteredTags = computed(() => {
  const q = (tagSearch.value || '').toLowerCase()
  return q ? dataTags.value.filter(t => (t as any)?.name.toLowerCase().includes(q)) : dataTags.value
})
const collator = new Intl.Collator('zh-CN')
const HAN_RE = /[\u4e00-\u9fa5]/
const initialBounds: Array<{ ch: string, letter: string }> = [
  { ch: '阿', letter: 'A' }, { ch: '芭', letter: 'B' }, { ch: '擦', letter: 'C' }, { ch: '搭', letter: 'D' },
  { ch: '蛾', letter: 'E' }, { ch: '发', letter: 'F' }, { ch: '噶', letter: 'G' }, { ch: '哈', letter: 'H' },
  { ch: '机', letter: 'J' }, { ch: '喀', letter: 'K' }, { ch: '垃', letter: 'L' }, { ch: '妈', letter: 'M' },
  { ch: '拿', letter: 'N' }, { ch: '哦', letter: 'O' }, { ch: '啪', letter: 'P' }, { ch: '期', letter: 'Q' },
  { ch: '然', letter: 'R' }, { ch: '撒', letter: 'S' }, { ch: '塌', letter: 'T' }, { ch: '挖', letter: 'W' },
  { ch: '昔', letter: 'X' }, { ch: '压', letter: 'Y' }, { ch: '匝', letter: 'Z' }
]
const letterOf = (s: string) => {
  const c = (s && s[0]) || ''
  if (!c) return '#'
  const up = c.toUpperCase()
  if (up >= 'A' && up <= 'Z') return up
  if (HAN_RE.test(c)) {
    for (let i = initialBounds.length - 1; i >= 0; i--) {
      if (collator.compare(c, initialBounds[i].ch) >= 0) return initialBounds[i].letter
    }
    return 'A'
  }
  return '#'
}
const groupedTags = computed(() => {
  const groups: Record<string, string[]> = {}
  for (const t of filteredTags.value) {
    const letter = letterOf((t as any)?.name || '')
    if (!groups[letter]) groups[letter] = []
    groups[letter].push(t)
  }
  for (const k of Object.keys(groups)) {
    groups[k].sort((a, b) => (a as any)?.name.localeCompare((b as any)?.name, 'zh-CN'))
  }
  const order = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)).concat('#')
  return order.filter(l => groups[l]?.length).map(l => ({ letter: l, items: groups[l] }))
})
const toggleTag = (t: string) => {
  const i = form.value.tags.findIndex((x: any) => x.id == (t as any).id)
  if (i >= 0) form.value.tags.splice(i, 1)
  else form.value.tags.push(t)
}
const addTagVisible = ref(false)
const addTagName = ref('')
const onAddTag = () => { addTagName.value = ''; addTagVisible.value = true }
const confirmAddTag = () => {
  const n = addTagName.value
  if (!n) return
  createTag({ name: n, owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code) }).then(res => {
    if (res.data.data.id) {
      getTagPagedata()
      addTagVisible.value = false
    }
  })

  // return
  // if (!localTags.value.includes(n)) localTags.value.push(n)
  // if (!form.value.tags.includes(n)) form.value.tags.push(n)
}

const addCategoryVisible = ref(false)
const addCategoryName = ref('')
const openAddCategory = () => { addCategoryName.value = ''; addCategoryVisible.value = true }
const confirmAddCategory = () => {
  const n = addCategoryName.value
  if (!n) return
  createCategory({ name: n, owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code) }).then(async res => {
    if (res.data.data.id) {

      await getCategoryPagedata()
      form.value.category = res.data.data.id
      addCategoryVisible.value = false
    }
  })
  // if (!n) return
  // if (!localCategories.value.includes(n)) localCategories.value.push(n)
  // form.value.category = n
  // addCategoryVisible.value = false
}
const onRemoveFile = (i: number) => { emit('removeFile', i) }
onMounted(() => {
  getTagPagedata()
  getCategoryPagedata()
})
const getTagPagedata = async () => {
  const res = await getTagPage({ owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code), page: 1, size: 100 })
  try {
    localTags.value = res.data.data.items
    console.log(localTags.value)
  } catch (error) {
    localTags.value = []
  }
  return
}
const getCategoryPagedata = async () => {
  const res = await getCategoryPage({ owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code), page: 1, size: 100 })
  try {
    localCategories.value = res.data.data.items
  } catch (error) {
    localCategories.value = []
  }
  return
}
const uploading = ref(false)
const loadingtext = ref('上传中...')
const confirmUpload = async () => {
  const { tags, category } = form.value
  const tag_ids = tags.map((t: any) => t.id).join(',')
  uploading.value = true
  try {
    await uploadNext(0, tag_ids, category)
    innerVisible.value = false
    form.value.tags = []
    form.value.category = ''
    emit('confirm', { category, tags, files: props.files })
  } finally {
    uploading.value = false
  }
}
const uploadNext = async (i: number, tag_ids: string, category: any) => {
  if (!props.files || i >= props.files.length) return
  const file = props.files[i]
  await resourcerFileUpload(file, (props.folder as any)?.id, ((props.currentTeam as any)?.corp_code), tag_ids, category)
  loadingtext.value = `上传中...${i + 1}/${props.files.length}`
  await uploadNext(i + 1, tag_ids, category)
}

</script>
<style lang="scss" scoped>
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}

.dialog-header .title {
  font-size: 16px;
  font-weight: 600;
  color: #0b1029
}

.dialog-header .collapse {
  font-size: 12px;
  color: #8a8f99;
  cursor: pointer
}

.info-line {
  display: flex;
  align-items: center;
  padding: 0 8px 16px;
  padding-left: 0
}

.info-line .team {
  font-size: 14px;
  color: #0b1029;
  font-weight: 600
}

.info-line .hint {
  font-size: 12px;
  color: #8a8f99
}

.link {
  color: #2a66ff;
  text-decoration: none;
  cursor: pointer;
}

.dialog-body {
  display: flex;
  min-height: 600px;
}

.dialog-body.collapsed {
  gap: 0
}

.left {
  flex: 1;
  display: grid;
  gap: 16px;
  align-items: start
}

.upload-tile {
  width: 118px;
  height: 118px;
  border-radius: 12px;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #eef1f5
}

.plus {
  font-size: 30px;
  color: #2a66ff;
  line-height: 1
}

.text {
  font-size: 12px;
  color: #8a8f99
}

.file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.file-item {
  width: 118px;
}

.thumb {
  position: relative;
  width: 118px;
  height: 118px;
}

.thumb img {
  width: 118px;
  height: 118px;
  border-radius: 12px;
  object-fit: cover;
  border: 1px solid #eef1f5
}

.file-placeholder {
  width: 118px;
  height: 118px;
  border-radius: 12px;
  background: #eef1f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2a66ff;
  font-weight: 700;
  border: 1px solid #e6e8eb
}

.type-badge {
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: #0b1029;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 6px
}

.file-item:hover .type-badge {
  opacity: 0
}

.delete-overlay {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 1px #e6e8eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0b1029
}

.caption {
  margin-top: 6px;
  font-size: 12px;
  color: #38393b
}

.right {
  width: 380px
}

.field .label {
  font-size: 14px;
  color: #0b1029;
  font-weight: 600
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px
}

.tag {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  gap: 6px
}

.tag .text {
  font-size: 12px;
  color: #38393b
}

.tag-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: #f5f7fa;
  color: #8a8f99
}

.storage {
  display: grid;
  gap: 8px;
  margin-top: 8px;
  color: #38393b
}

.btn {
  display: inline-flex;
  gap: 12px
}

/* Tag picker styles */
.tag-picker {
  display: grid;
  grid-template-rows: auto auto 1fr;
  gap: 12px;
  padding: 4px 8px 12px;
}

.tp-search {
  width: 100%;
}

.tp-search :deep(.el-input__wrapper) {
  background-color: #f5f7fa;
  border: 1px solid #eef1f5;
  box-shadow: none;
  border-radius: 10px;
  height: 32px;
}

.tp-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #2a66ff;
  cursor: pointer;
  user-select: none;
}

.tp-list {
  max-height: 360px;
  overflow: auto;
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 8px;
}

.tp-group {
  margin-bottom: 10px;
}

.tp-letter {
  font-size: 12px;
  color: #8a8f99;
  margin-bottom: 6px;
}

.tp-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tp-chip {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  font-size: 12px;
  color: #38393b;
  background: #fff;
  cursor: pointer;
}

.tp-chip:hover {
  border-color: #dfe3e8;
  background: #f5f7fa;
}

.tp-chip.active {
  border-color: #2a66ff;
  color: #2a66ff;
  background: #eaf2ff;
}
</style>
